import React from 'react';
import styled from 'styled-components';

const SubscriptionMessage = (props) => {
  const { show } = props;

  if (!show) return null;
  return (
    <StyledSubscriptionText>
      App price does not include subscription to other software.
    </StyledSubscriptionText>
  );
};

const StyledSubscriptionText = styled.p`
  color: var(--gray-dark);
  font-weight: var(--font-weight-base);
  font-size: var(--font-size-sm);
  margin-top: 20px;
`;

export default SubscriptionMessage;
